'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Component } from 'react';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
class FilterOperatorPropertyInputOption extends Component {
  render() {
    /* eslint-disable-next-line react/prop-types, react/prop-types */
    const _this$props = this.props,
      {
        children,
        option
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: /*#__PURE__*/_jsx(UITooltip
      /* eslint-disable-next-line react/prop-types */, {
        disabled: !option.disabled,
        placement: "right",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterOperatorPropertyInput.titleCantCompareToItself"
        }),
        children: children
      })
    }));
  }
}
export default FilterOperatorPropertyInputOption;